import { ProductFilter } from '../../../models/Product';

export default class FilterUtils {
    static hasActiveFilter(filters: ProductFilter) {
        return (
            Object.values(filters).filter(
                item =>
                    (item.includeFilterValues?.length ?? 0) > 0 ||
                    (item.excludeFilterValues?.length ?? 0) > 0 ||
                    (item.include?.length ?? 0) > 0 ||
                    (item.exclude?.length ?? 0) > 0
            ).length > 0
        );
    }
}
